import { render, staticRenderFns } from "./SDFakeSelectBox.vue?vue&type=template&id=1304050f&scoped=true&"
import script from "./SDFakeSelectBox.vue?vue&type=script&lang=ts&"
export * from "./SDFakeSelectBox.vue?vue&type=script&lang=ts&"
import style0 from "./SDFakeSelectBox.vue?vue&type=style&index=0&id=1304050f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304050f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1304050f')) {
      api.createRecord('1304050f', component.options)
    } else {
      api.reload('1304050f', component.options)
    }
    module.hot.accept("./SDFakeSelectBox.vue?vue&type=template&id=1304050f&scoped=true&", function () {
      api.rerender('1304050f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/SDFakeSelectBox.vue"
export default component.exports